(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["exxtra-hero"] && !Shopify.designMode) return;
  try {
    
  // Small UX nicety — horizontal wheel scroll for pills
  const sectionEl = document.currentScript.closest('section');
  const scrollers = sectionEl.querySelectorAll('.pill-scroller');
  scrollers.forEach(el => {
    el.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        el.scrollLeft += e.deltaY; e.preventDefault();
      }
    }, { passive: false });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exxtra-heroV2"] && !Shopify.designMode) return;
  try {
    
  // No script needed for now; kept for future enhancements (e.g., animated chips)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
